import { Component, Inject, OnInit } from '@angular/core';
import { VersionResponse, XProjectorClient } from '../../XProjector/xprojector-client-service';

import { LOGGERSERVICE, XprojLoggerService } from '../../logger/xproj-logger-service';
import { DateHelper } from 'xproj-lib';

@Component({
  selector: 'xproj-about',
  templateUrl: './xproj-about.component.html',
  styleUrls: ['./xproj-about.component.scss'],
  host: {
    class:'content-container'
}
})

export class XProjAboutComponent implements OnInit {

  version : VersionResponse;

  constructor(public xprojClient: XProjectorClient,
    public dateHelper: DateHelper,
    @Inject(LOGGERSERVICE) private logger: XprojLoggerService)
  {

  }

  ngOnInit() {
    this.updateVersion();
  }

  async updateVersion() {
    this.version = await this.xprojClient.RequestGetVersion();
  }

}
